export default __webpack_public_path__ + "static/media/Mark-2-HUD-Label.d573ac52.jpg";